<div>
  <div class="relative">
    <div
      class="flex items-center gap-1 rounded-md bg-white px-3 outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-blue-royal w-full h-[36px]"
      [class.outline-red-500]="required && formControl?.errors?.['required'] && formControl?.touched"
    >
      <input
        type="text"
        class="flex-grow outline-none min-w-[120px] bg-white text-gray-900 border-none focus:ring-0 focus:outline-none placeholder:text-sm placeholder:text-gray-400 text-sm leading-none h-full"
        autocomplete="off"
        role="combobox"
        [attr.aria-expanded]="isOpen"
        [placeholder]="placeholder"
        (input)="onSearchTermChange($event)"
        (click)="onInputClick($event)"
        (keydown)="onInputKeydown($event)"
        [value]="searchTerm"
      />
      <button
        type="button"
        class="flex items-center pl-2 focus:outline-none"
        (click)="toggleDropdown($event)">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
          class="text-gray-400 hover:text-gray-600 transition-transform duration-200"
        >
          <polyline points="7 15 12 20 17 15"></polyline>
          <polyline points="7 9 12 4 17 9"></polyline>
        </svg>
      </button>
    </div>

    <ul
      *ngIf="isOpen"
      class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
      id="options"
      role="listbox"
    >
      <!-- Group options by parent name -->
      <ng-container *ngFor="let group of groupedOptions | keyvalue">
        <li *ngIf="hasMultipleGroups" class="relative py-2 pl-3 pr-9 bg-gray-100 font-medium">
          {{ group.key }}
        </li>
        <li
          *ngFor="let option of group.value"
          class="relative cursor-default select-none py-2 pl-7 pr-9 text-gray-900 hover:bg-gray-50"
          (click)="toggleSelection(option)"
          role="option"
        >
          <div class="flex items-center">
            <input
              *ngIf="option[valueKey] !== null"
              type="checkbox"
              class="form-checkbox h-4 w-4 text-primary border-gray-300 rounded"
              [checked]="isSelected(option)"
              (click)="$event.stopPropagation()"
              (change)="toggleSelection(option)"
            />
            <span class="ml-3 block truncate">{{ option[displayKey] }}</span>
          </div>
        </li>
      </ng-container>

      <!-- Show "not found" when no results -->
      <li *ngIf="!hasGroupedOptions" class="relative cursor-default select-none py-2 pl-3 pr-9 text-gray-500">
        No results found
      </li>
    </ul>
  </div>

  <!-- Selected options pills -->
  <div class="-m-1 flex flex-wrap items-center mt-2" *ngIf="selectedOptions.length > 0">
    <span *ngFor="let option of selectedOptions" class="m-1 inline-flex items-center rounded-full border border-gray-200 bg-white py-1.5 pl-3 pr-2 text-xs font-medium text-gray-900">
      <span>{{ option[displayKey] }}</span>
      <button type="button" class="ml-1 inline-flex h-4 w-4 flex-shrink-0 rounded-full p-1 text-gray-400 hover:bg-gray-200 hover:text-gray-500" (click)="removeSelectedOption(option)">
        <span class="sr-only">Remove {{ option[displayKey] }}</span>
        <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
          <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
        </svg>
      </button>
    </span>
  </div>
</div>

